const HospitalsSelector = ({
	onHospitalSelected,
	role,
	data
}) => {
	const handleChange = (event) => {
		const { value } = event.target;
		onHospitalSelected(value);
	};
	return (
		<select name='city'
			className='form-control study-state-selector'
			onChange={handleChange}
		>
			<option value='none'>Select </option>
			{data.map(city => {
				return <option key={city._id} value={city._id}>
					{city.name}
				</option>
			})}
			
		</select>
	);
};

export default HospitalsSelector;
